import React,{useState,useEffect} from 'react'
import { confirmPassResetUser, getStudentUser, getTeacherUser, loginUser, requestPassResetUser } from '../../api/authService'
import useApi from '../../api/useApi'
import {
    Box,
    Typography,
    TextField,
    Button,
    Divider,
    IconButton,
    Stack,
  } from "@mui/material";
  import {
    Visibility,
    VisibilityOff,
    PersonAdd,
    Settings,
  } from "@mui/icons-material";
import { Link, useNavigate,useLocation } from 'react-router-dom'
import { toast } from 'react-toastify';
import {useAuth} from '../../hooks/useAuth';



function PassResetConfirmForm() {
    const navigate = useNavigate()
    const { login } = useAuth();
    const location = useLocation()

    const redirect = location?.state?.from?.pathname || "/s"; 

    const [form,setForm] = useState({})
    const { request: confirmPassResetuser, data, error, isLoading } = useApi(confirmPassResetUser);
    const { request: getStduser, data:stdData, error:stdError } = useApi(getStudentUser);
    const { request: getTchuser, data:tchData, error:tchError } = useApi(getTeacherUser);
    const onchange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        }; 
    const loginFormInvalid =
    form?.password!==form?.confirm_password||!form?.password || !form.password.length;
    const [viewPass,setViewPass] = useState("password")
    const handleClick = (e)=>{
        e.preventDefault()
        
        // if(!form?.username){
        //     form.username = ""
        // }
        // if(!form?.middle_name){
        //     form.middle_name = ""
        // }
        // console.log(form)
        delete form?.confirm_password
        if(location?.state?.uidb64){
            form.uidb64 = location?.state?.uidb64
        }

        if(location?.state?.token){
            form.token = location?.state?.token
        }
        confirmPassResetuser(form)
        // console.log(isLoading)
        // console.log(data)
        // console.log(error)
        
    }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const uidb64 = queryParams.get('uidb64');
    const token = queryParams.get('token');

    if (uidb64 && token) {
      // Redirect and store them in location.state
      navigate('/password-reset/confirm', {
        state: { uidb64, token },
        replace: true, // optional: avoids back button returning to query version
      });
    }
  }, [location, navigate]);
    
    useEffect(() => {
        if(error){
            toast.error(`${JSON.stringify(error?.response?.data,null,2)}`,{position: "top-center"});
            // setForm({})
        }
    },[error])

    useEffect(() => {
        if(stdError){
            toast.error(`${JSON.stringify(stdError?.response?.data,null,2)}`,{position: "top-center"});
            // setForm({})
        }
    },[stdError])

    useEffect(() => {
        if(tchError){
            toast.error(`${JSON.stringify(tchError?.response?.data,null,2)}`,{position: "top-center"});
            // setForm({})
        }
    },[tchError])

    useEffect(() => {
        if(data){
            console.log(data)
            toast.success(`${JSON.stringify(data?.data)}`,{position: "top-center"});
            if(data?.status ===200){
                // const { tokens, ...userData } = data?.data
                setForm({})
                navigate('/signin', {
                    replace: true, // optional: avoids back button returning to query version
                });
            }
        } 
      }, [data,navigate]);

    useEffect(()=>{

    if(stdData?.status===200){
        const { tokens, ...userData } = data?.data

        login({userData: userData, jwtToken: tokens,student:stdData?.data})
        let redirect_url = location?.state?.from?.pathname || "/s"; 
            setTimeout(()=>{
                navigate(redirect_url,{ replace: true })
                },2000)
                setForm({})
        }
      },[stdData,navigate])


    useEffect(()=>{

     if(tchData?.status===200){
        const { tokens, ...userData } = data?.data

        login({userData: userData, jwtToken: tokens,teacher:tchData})
        let redirect_url_b = location?.state?.from?.pathname || "/t"; 
            setTimeout(()=>{
                navigate(redirect_url_b,{ replace: true })
                },2000)
                setForm({})

       }
      },[tchData,navigate])

    const setView = ()=>(setViewPass("text"))
    const setClose = ()=>(setViewPass("password"))
    return (
        <Box className="Form-Signup" sx={{ display: "flex", flexDirection: "row" }}>
        <Box className="Form-A" sx={{ flex: 1 }}></Box>
  
        <Box className="Form-B" sx={{ flex: 2, textAlign: "center", p: 4 }}>
          {/* Page Header */}
          <Typography variant="h5" gutterBottom>
            Fountain Africa Trust
          </Typography>
  
          {/* Icons (replacing IconGroup) */}
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            sx={{ mb: 2 }}
          >
            <PersonAdd sx={{ fontSize: 40, color: "teal" }} />
            <Settings sx={{ fontSize: 25, color: "grey" }} className="spin" />
          </Stack>
  
          <Typography variant="h6" gutterBottom>
            Enter New Password
          </Typography>
  
          {/* Form Section */}
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "100%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            noValidate
            autoComplete="off"
          >
            {/* Password Input with visibility toggle */}
            <Box sx={{ position: "relative", width: "100%", m: 1 }}>
              <TextField
                required
                label="Password"
                type={viewPass === "password" ? "password" : "text"}
                name="password"
                placeholder="Enter your password"
                value={form?.password || ""}
                onChange={onchange}
                fullWidth
                variant="outlined"
              />
              <IconButton
                onClick={viewPass === "password" ? setView : setClose}
                sx={{ position: "absolute", right: 30, top: 15 }}
              >
                {viewPass === "password" ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </Box>
  
            {/* Confirm Password Input */}
            <TextField
              required
              label="Confirm Password"
              type="password"
              name="confirm_password"
              placeholder="Confirm your password"
              value={form?.confirm_password || ""}
              onChange={onchange}
              variant="outlined"
              sx={{ width: "100%", m: 1 }}
            />
  
            {/* Submit Button */}
            <Button
              fullWidth
              variant="contained"
              color="primary"
              disabled={loginFormInvalid}
              onClick={handleClick}
              sx={{ mt: 2 }}
            >
              {isLoading ? "Loading..." : "Reset your password"}
            </Button>
  
            <Divider sx={{ my: 2 }}>or</Divider>
  
            <Typography variant="body2" sx={{ mt: 1 }}>
              Have a staff account? <Link to="/signin">Sign In</Link>
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Don’t have a staff account? <Link to="/signin">Contact Admin</Link>
            </Typography>
          </Box>
        </Box>
  
        <Box className="Form-C" sx={{ flex: 1 }}></Box>
      </Box>
  )
}

export default PassResetConfirmForm